module.exports = __webpack_public_path__ + "media/images/favicons/site-tile-310x310-4d0fa6c686407cdad6f2cfdbd6dd45e7.png";